import { IconDownload, IconTrash } from '@tabler/icons-react';
import { classnames } from '@/libs/utils';

export default function MultiSelectFooter({
  selectedCount,
  onCancel,
  onDelete,
  onDownload
}: {
  selectedCount: number;
  onCancel: () => void;
  onDelete: () => void;
  onDownload: () => void;
}) {
  const hasSelection = selectedCount > 0;

  return (
    <div className="flex items-center justify-between">
      <button className="text-sm font-medium text-slate-600 hover:text-slate-900" onClick={onCancel}>
        Cancel
      </button>
      <div className="flex items-center space-x-2">
        <button
          disabled={!hasSelection}
          onClick={onDelete}
          className={classnames(
            'flex items-center space-x-1.5 rounded-lg px-3 py-1.5 text-sm font-medium transition-colors',
            hasSelection ? 'text-red-600 hover:bg-red-50' : 'cursor-not-allowed text-slate-300'
          )}
        >
          <IconTrash size={16} />
          <span>Delete</span>
        </button>
        <button
          disabled={!hasSelection}
          onClick={onDownload}
          className={classnames(
            'flex items-center space-x-1.5 rounded-lg px-3 py-1.5 text-sm font-medium transition-colors',
            hasSelection
              ? 'bg-slate-900 text-white hover:bg-slate-700'
              : 'cursor-not-allowed bg-slate-100 text-slate-400'
          )}
        >
          <IconDownload size={16} />
          <span>Download</span>
        </button>
      </div>
    </div>
  );
}
